import { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { FormattedDate, FormattedMessage } from 'react-intl'
import HeaderMetedBase from './HeaderMetedBase'
import Footer from './Footer'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getFullLesson } from '../../actions'
import { PulseLoader } from 'react-spinners'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'

const LessonDetailsContainer = (props) => {

    const {dispatch, viewer, module, user} = props;

    const {logged_in} = user.metadata;
    const {lesson_initialized} = viewer;
    //const {quizzes, surveyETC} = user;

    //ETC SURVEY QUESTION
    //let showEtcSurveyQuestion = (quizzes.quiz.bestResults !== null) ? true : false;
    //let showEtcSurveyQuestion = true;

    const {server} = viewer;
    const {type} = module.metadata;

    const params = useParams();

    const lesson = useSelector(state => state.module);
    let lessonThumbnailPath = lesson.metadata.thumbnailPath ? `/images/product_thumbs/${lesson.metadata.thumbnailPath}` : `${server}/images/product_thumbs/placeholder.png`;


    //Init hook
    useEffect(() => {
        window.scrollTo(0,0);
        dispatch(getFullLesson(params.id));
    }, [dispatch, params.id]);


    return (
        <div id='lesson-details-page'>
            <HeaderMetedBase />
            <main className="mx-auto max-w-7xl sm:px-6 lg:px-8">

                <div className="bg-white">
                    <section aria-labelledby="features-heading" className="mx-auto max-w-7xl py-8 sm:px-2 lg:px-8">
                    
                        {/* ETC SURVEY QUESTION BANNER 
                        { (logged_in && lesson_initialized !== null) && showEtcSurveyQuestion
                        ? <EtcSurveyQuestion show={showEtcSurveyQuestion} data={surveyETC} />
                        : null} */}

                        {/* RETIRED LESSON DISPLAY */}
                        {lesson.metadata.archived === 'yes'
                        ?
                        <div className='mx-auto max-w-2xl px-4 md:max-w-none lg:px-0'>
                            <div className='sm:flex sm:flex-row'>
                                <div className='basis-2/3 pr-6'>
                                    <div>
                                        <div className="text-base font-semibold leading-7 text-red-800"><FormattedMessage id="splash.retire_message" defaultMessage="This lesson has been retired, and is no longer available." /></div>
                                        <h2 id="features-heading" className="text-2xl mb-4 font-bold tracking-tight text-gray-900 sm:text-2xl">{lesson.metadata.title}</h2>
                                    </div>
                                    <div className='text-gray-500 text-sm italic'>
                                        <p><FormattedDate value={new Date(lesson.metadata.archivedData.date_archived)} day="numeric" month="long" year="numeric" /></p>
                                        {lesson.metadata.archivedData.updated_module !== "0"
                                        ? <div className='my-4 space-y-2'>
                                            <p><FormattedMessage id='splash.updated_message' defaultMessage="The updated version of this lesson can be found here:" /></p>
                                            <a href={`${server}lesson/${lesson.metadata.archivedData.updated_module}`}
                                                className='inline-flex items-center gap-x-1.5 rounded-md border border-blue-300 bg-blue-600 px-14 py-4 text-md font-medium text-white shadow-sm hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-100'><FormattedMessage id='splash.retire_updated_lesson' defaultMessage="Go to updated lesson" /><ArrowTopRightOnSquareIcon className="h-4 w-4 inline" /></a>
                                          </div>
                                        : null}
                                    </div>
                                </div>
                                <div className='basis-1/3 border border-gray-200 rounded-md mt-4 p-4 justify-center'>
                                    <div className='hidden sm:block'>
                                        {lesson.metadata.thumbnailPath
                                        ? <img src={lessonThumbnailPath} alt={lesson.metadata.title} className='aspect-[4/3] max-h-44 rounded-md shadow-md my-0 m-auto' />
                                        :
                                        <div className="w-full animate-pulse flex-row items-center justify-center space-x-5">
                                            <div className="flex flex-col space-y-3">
                                                <div className="mx-auto aspect-[4/3] h-[150px] w-[200px] bg-gray-300 rounded-md shadow-md my-0 m-auto'">
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="mx-auto max-w-2xl px-4 md:max-w-none lg:px-0">
                            <div className='flex sm:hidden'>
                            {lesson.metadata.thumbnailPath
                            ? <img src={lessonThumbnailPath} alt={lesson.metadata.title} className='aspect-[4/3] max-h-44 rounded-md shadow-md my-0 m-auto' />
                            :
                            <div className="w-full animate-pulse flex-row items-center justify-center space-x-5">
                                <div className="flex flex-col space-y-3">
                                    <div className="mx-auto aspect-[4/3] h-[150px] w-[200px] bg-gray-300 rounded-md shadow-md my-0 m-auto'">
                                    </div>
                                </div>
                            </div>
                            }
                            </div>
                            <div className='sm:flex sm:flex-row'>
                                {/* THUMB */}
                                <div className='basis-1/3 p-4 justify-center'>
                                    <div className='hidden sm:block'>
                                        {lesson.metadata.thumbnailPath
                                        ? <img src={lessonThumbnailPath} alt={lesson.metadata.title} className='aspect-[4/3] max-h-44 rounded-md shadow-md my-0 m-auto' />
                                        :
                                        <div className="w-full animate-pulse flex-row items-center justify-center space-x-5">
                                            <div className="flex flex-col space-y-3">
                                                <div className="mx-auto aspect-[4/3] h-[150px] w-[200px] bg-gray-300 rounded-md shadow-md my-0 m-auto'">
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>

                                    {logged_in
                                    ?
                                    <div>
                                        {type === 'local'
                                        ?
                                        <div className="flex flex-inline justify-center"></div>
                                        : lesson_initialized !== null ?
                                        <div className='text-center'>
                                        <p className='text-xs italic text-gray-600 mt-4'>
                                            <FormattedMessage id="lesson.external_resource" defaultMessage="This content is not hosted on MetEd" />
                                        </p>    
                                        <div className='flex justify-center my-4 mx-0'>
                                            
                                        </div>
                                        </div>
                                        : null
                                        }

                                    </div>
                                    :
                                    lesson_initialized !== null
                                    ?                                        
                                    <div className='sr-only'>This content has not yet been migrated to the new MetEd platform. Please check back later for updates.</div>
                                    :
                                    <div className='flex justify-center p-9'>
                                        <PulseLoader color='gray' size={8} />       
                                    </div>                                  
                                    }
                                </div>

                                {/* TITLE */}
                                <div className="basis-2/3 pr-6 pt-2">
                                    {lesson.metadata.title 
                                    ?
                                    <div>
                                        {/*
                                        {lesson.metadata.type === 'local' 
                                        ? <div className="text-base font-semibold leading-7 text-blue-600"><FormattedMessage id='menu.lesson' defaultMessage='Lesson' /></div>
                                        : <div className="text-base font-semibold leading-7 text-teal-600"><FormattedMessage id='app.other_resource' defaultMessage='Other resource' /></div>
                                        }*/}
                                        
                                        <h2 id="features-heading" className="text-3xl mb-4 font-bold tracking-tight text-gray-900 sm:text-4xl">
                                            {lesson.metadata.title}
                                        </h2>
                                    </div>
                                    : 
                                    <div className="w-2/3 animate-pulse flex-row items-center justify-center space-x-5">
                                        <div className="flex flex-col">
                                            <div className="h-4 bg-blue-200 rounded-md dark:bg-blue-700 w-32 mb-4 hidden"/>
                                            <div className="w-full bg-gray-300 h-6 rounded-md "/>
                                        </div>
                                    </div>
                                    }
                                    

                                </div>

                                

                            </div>

                            <hr className='my-4' />


                            <div className='text-center mb-48'>
                                <p className='text-lg text-gray-700 italic text-center bg-amber-200 rounded-md p-4'>
                                    Note: This content has not been migrated to the new MetEd platform. Please check back later for updates.
                                </p>
                                <div className='my-12'>
                                <div className='flex flex-row justify-center'>
                                    <Link to="/"
                                    className='text-blue-500 hover:text-blue-700'>
                                        &larr; Back to MetEd
                                    </Link>
                                </div>
                                <div className='flex flex-row justify-center'>
                                    <Link to="https://learn.meted.ucar.edu/#/catalog"
                                    className='text-blue-500 hover:text-blue-700'>
                                        &larr; Back to Catalog
                                    </Link>
                                </div>
                                </div>
                            </div>

                           
                        </div>
                        }
                    </section>
                </div>
            </main>
            <Footer />

            
        </div >
    );
};

function mapStateToProps({viewer, module, course, user}){
	return { viewer, module, course, user }
}

export default connect(mapStateToProps)(LessonDetailsContainer);